import { ICheckbox, ICheckboxChangeArgs } from '@app/interfaces/checkbox';
import { IObservable, BehaviorSubject, ISubject } from '@app/utils/observable';

export class CheckboxComponent<T> implements ICheckbox<T> {
    public readonly id: T;
    protected readonly changeEventSubject: ISubject<CheckboxComponent<T>, ICheckboxChangeArgs<T>>;
    private lastCheckedState!: boolean;
    private willStopPropagationOnClick: boolean = false;

    public get onChange$(): IObservable<CheckboxComponent<T>, ICheckboxChangeArgs<T>> {
        return this.changeEventSubject;
    }

    constructor(protected checkbox: HTMLInputElement) {
        this.changeEventSubject = new BehaviorSubject;

        this.id = $(this.checkbox).data("id") || this.checkbox.name;

        this.attachEventListenerToCheckbox();
    }

    get checked() {
        return this.checkbox.checked;
    }

    set checked(toggle: boolean) {
        this.checkbox.checked = toggle;
        if (this.lastCheckedState !== toggle) {
            this.emit();
        }
    }

    get disabled() {
        return this.checkbox.disabled;
    }

    set disabled(value: boolean) {
        this.checkbox.disabled = value;
    }

    reset() {
        this.checked = this.checkbox.defaultChecked;
    }

    set stopPropagationOnClick(value: boolean) {
        this.willStopPropagationOnClick = value;
    }

    protected emit() {
        this.lastCheckedState = this.checkbox.checked;
        this.changeEventSubject.emit(this, {
            key: this.id,
            checked: this.checkbox.checked,
        });
    }

    private attachEventListenerToCheckbox() {
        this.checkbox.addEventListener("change", ev => {
            this.emit();
        });

        this.checkbox.addEventListener("click", ev => {
            if (this.willStopPropagationOnClick) {
                ev.stopPropagation();
            }
        });

        // Initial state
        this.emit();
    }
}